import Vue from "vue";
import Vuex from "vuex";

import auth from "@/store/Auth/Auth";
import accounts from "@/store/Accounts/Accounts";
import creditControl from "@/store/Accounts/CreditControl";
import creditControlDashboard from "@/store/Accounts/CreditControlDashboard";
import creditnotes from "@/store/CreditNotes/CreditNotes";

import products from "@/store/Products/ProductsView";
import productWebsite from "@/store/Products/ProductWebsite";
import productTelco from "@/store/Products/ProductTelco";
import productGeneral from "@/store/Products/ProductGeneral";
import changeTariff from "@/store/Products/ChangeTariff";

import adhoc from "@/store/Products/AdhocInvoice";
import productCli from "@/store/Products/Cli";
import upfrontcosts from "@/store/Products/UpfrontCostsCard";
import numbers from "@/store/Products/Numbers";
import productNotes from "@/store/Products/Notes";
import productList from "@/store/Products/ProductList"
import enterpriseConfiguration from "@/store/Products/enterpriseConfiguration";
import productHardware from "@/store/Products/ProductHardware";
import productLinks from "@/store/Products/ProductLinks";
import moveToAccount from "@/store/Products/MoveToAccount";
import trustpilotEmail from '@/store/Products/TrustpilotEmail';

import globals from "@/store/Globals/Globals";
import alerts from "@/store/Globals/Alerts";
import localCache from "@/store/Globals/LocalCache";
import crmUsers from "@/store/Globals/crmUsers";

import retention from "@/store/Retentions/Retentions";
import daily from "@/store/DailyLeads/DailyLeads";
import leads from "@/store/SalesLeads/SalesLeads";
import numberTransfers from "@/store/NumberTransfers/NumberTransfers";
import tickets from "@/store/Tickets/Tickets";
import comms from "@/store/Comms/Comms";

import numberpoolAdmin from "@/store/Admin/NumberPool";
import staticData from "@/store/StaticData";
import sms from "@/store/Products/sms";

import cpl from "@/store/Marketing/Cpl";
import telcoWorkflow from '@/store/TelcoWorkflow/telcoWorkflow';
import ledger from '@/store/Ledger';
import demos from '@/store/Demos/demos';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    creditnotes,
    accounts,
    creditControl,
    globals,
    products,
    productTelco,
    productGeneral,
    changeTariff,
    productWebsite,
    adhoc,
    productCli,
    upfrontcosts,
    enterpriseConfiguration,
    retention,
    numbers,
    alerts,
    daily,
    productNotes,
    leads,
    productList,
    localCache,
    productHardware,
    productLinks,
    moveToAccount,
    trustpilotEmail,
    crmUsers,
    numberTransfers,
    tickets,
    comms,
    numberpoolAdmin,
    staticData,
    sms,
    cpl,
    telcoWorkflow,
    creditControlDashboard,
    ledger,
    demos,
  },
});
